import React, { useEffect, useState } from 'react';
import gql from 'graphql-tag';
import { useParams } from 'react-router-dom';
import client from '../../utils/prismicHelpers';
import * as queries from "../../utils/prismicQueries";
import './event.css'
import img from "../../assets/images/AAM 840_300 (1).png"
import bannerTop from "../../assets/images/AAM banner link online 1300_400.png"
import Agenda from './Agenda';
import BreadCrumb from '../../main/components/BreadCrumb';
import SpeakerSlider from './SpeakerSlider';
import AgendaSlider from './AgendaSlider';
const Event = () => {
    const [envetInfo, setEventInfo] = useState(null);
    const { id } = useParams();

    // teamInfo.node._meta.uid
    useEffect(() => {
        client.query({ query: queries.event })
            .then((response) => {
                const eventsDoc = response.data.allNew_events.edges;
                const newEvent = eventsDoc?.find(eventDoc => eventDoc?.node?._meta?.uid === id)
                setEventInfo(newEvent?.node);

                window.scrollTo(0, 0);
            })
            .catch((error) => {
                console.error(error);
            });
    });
    return (
        <>

            <section style={{ backgroundImage: 'url(' + envetInfo?.section_bg?.url + ')' }} className="pattern chart-container">
                <div className="container">
                    <BreadCrumb nested={"Events"} />
                    <h3 className="subtitle ">{envetInfo?.title}</h3>
                    <div className=" mb-3 border-0" style={{ backgroundColor: "#ffffff00" }} >
                        <img src={envetInfo?.top_banner?.url} className="img-fluid" alt="" />
                    </div>
                    <div className="speaker-container">
                        <div className="row">
                            <div className="col-md-5">
                                <div className="d-flex  mt-3 justify-content-between">

                                    <a target="_blank" href={envetInfo?.reg_link}> <button className="primary-btn   px-5">{envetInfo?.reg_btn_text}</button></a>

                                </div>
                            </div>
                        </div>
                        <div >
                            {envetInfo?.speakers?.length > 0 ?
                                <SpeakerSlider speakerSlider={envetInfo?.speakers} title={envetInfo?.speakers_title} />
                                : null
                            }

                        </div>
                        <div className=" mt-2">
                            <h5 className="techno-title"> {envetInfo?.summary_title}</h5>
                            <ul className="list-unstyled">
                                {envetInfo?.summery?.map(paras => <li className="py-2">{paras?.para}</li>)}
                            </ul>


                        </div>
                    </div>
                    <div >
                        <div className="d-block d-md-none">
                           
                            {envetInfo?.agenda_info ? <AgendaSlider agentInfos={envetInfo?.agenda_info} /> : null}

                        </div>
                        <div className="d-none d-md-block ">
                            <div className="row  g-2">
                                <h5 className="techno-title">{envetInfo?.agenda_title}</h5>
                                {envetInfo?.agenda_info ? envetInfo?.agenda_info?.map((agentInfo, index) => <Agenda key={index + 1} agentInfo={agentInfo} />) : null}
                            </div>
                        </div>
                    </div>
                    <div className="event-footer text-center mt-5">
                        <p>{envetInfo?.footer.slice(0, 15)} <a href="mailto:marketing@artpark.in">{envetInfo?.footer.slice(15, 35)}</a>{envetInfo?.footer.slice(35, 500)}</p>
                        {/* <p >Please contact <a href="mailto:marketing@artpark.in">marketing@artpark.in</a> or  <a href="mailto:hemant@artpark.in">hemant@artpark.in</a>  for any queries related to the seminar</p> */}
                    </div>
                </div>
            </section >
        </>
    );
};

export default Event;